module.exports = __webpack_public_path__ + "img/one-time-icon.a38b266d.svg";